export interface Resource {
  id: number;
  accessLevel: number;
}

const keysToParse = [
  "pickupDate",
  "approvedDate",
  "startDate",
  "createdOn",
  "changedOn",
  "updatedOn",
  "dueDate",
  "shippingDate",
  "transporterDate",
  "lastUpdateTime",
  "twsCheckDate",
];

export function parseJSONDates(jsonObject: any): void {
  // Ignore things that aren't objects.
  if (typeof jsonObject === "object") {
    Object.entries(jsonObject).forEach(([key, value]) => {
      if (keysToParse.includes(key) && value) {
        jsonObject[key] = tryParseJsonDate(value);
      } else if (typeof value === "object" && value) {
        parseJSONDates(value);
      }
    });
  }
}

export function tryParseJsonDate(value: any): Date {
  console.log(value, typeof value);
  let milliseconds = Date.parse(value);
  return new Date(milliseconds);
}

export class BaseResource implements Resource {
  id: number;
  accessLevel: number;

  constructor(options?: any) {
    if (options) {
      parseJSONDates(options);
      Object.assign(this, options);
    }
  }

  public get isNew(): boolean {
    return !this.id;
  }

  public toString() {
    return Object.prototype.toString.call(this);
  }
}
